















import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import cookieMixin from '@/mixins/cookie';

@Component
export default class CheckBox extends mixins(cookieMixin) {
  @Prop() private name!: string;
  @Prop() private id!: string;
  @Prop() private namespace!: string;
  @Prop() private state!: string;

  created() {
    this.checked = this.findBoolean(this.payload);
    this.saveStatus();
  }

  get payload() {
    return { id: this.id };
  }

  get checked() {
    return this.$store.getters[`${this.namespace}/${this.state}`];
  }
  set checked(value: boolean) {
    this.$store.commit(`${this.namespace}/${this.state}`, value);
  }

  private saveStatus(): void {
    this.saveValue(this.payload, this.checked);
  }
}
